import { render, staticRenderFns } from "./AddColiseum.vue?vue&type=template&id=708cb2e4"
import script from "./AddColiseum.vue?vue&type=script&lang=js"
export * from "./AddColiseum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports